<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
    <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__body">
            <ng-container *ngIf="canViewRaffleEvent">
                <kt-raffle-event-detail></kt-raffle-event-detail>
            </ng-container>
        </div>
    </div>
</div>